import comboTree from './src/combo-tree.vue'

import type { App } from 'vue'
import type { SFCWithInstall } from '@sgui-plus/utils/types'

comboTree.install = (app: App): void => {
  app.component(comboTree.name, comboTree)
}

const _Tree = comboTree as SFCWithInstall<typeof comboTree>

export default _Tree
export const SgComboTree = _Tree
